import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import ErrorComponent from "Common/components/ErrorComponent";
import { STATUS_FAILURE, STATUS_PENDING } from "Common/constants/commonConstants";
import { authorize, resetAuthorizeFailureStatus } from "../store/AuthorizationAction";
import LoaderComponent from "Common/components/LoaderComponent";

function AuthorizationComponent({ authData, children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (process.env.INTEGRATE_UM && process.env.INTEGRATE_UM === "true") {
      const url = `${process.env.UM_API}/authorize?applicationId=${process.env.UM_APPLICATION_ID}`;
      dispatch(authorize(url, process.env.UM_API_SCOPE));
    }
  }, []);

  const handleUnauthorizedPopupClose = () => {
    dispatch(resetAuthorizeFailureStatus());
  };

  return (
    <>
      {(!process.env.INTEGRATE_UM ||
        process.env.INTEGRATE_UM === "false" ||
        !!authData.authorizedAssignedRoles.length) &&
        children}
      <ErrorComponent
        show={authData.authorizeRequestStatus === STATUS_FAILURE}
        heading="Error"
        message={authData.authorizeRequestError}
        handleClose={handleUnauthorizedPopupClose}
      />
      <LoaderComponent
        show={authData.authorizeRequestStatus === STATUS_PENDING}
      />
    </>
  );
}

function select(state) {
  return {
    authData: state.AuthorizationReducer,
  };
}
export default connect(select)(AuthorizationComponent);
